import Vue from "vue";
import request from "./http";
const Http = {};
const prefix = "http";
Http.install = function(Vue) {
  if (Http.installed) return;
  Http.installed = true;

  Vue[prefix] = Vue.prototype[`$${prefix}`] = request;
};
Vue.use(Http);
